export default "__VITE_ASSET__BYKOE3cd__"